export const AUDITORY_MODEL = {
  paso: 3,
  pasoDescripcion: "PASO_PAGO",
};

export const PAYMENT_MODEL = {
  title: "Finaliza tu <strong>compra</strong>",
  terms:
    "Al pagar autorizo el cargo automático a la tarjeta registrada para este pago.",
  errorStep: "/comprar/seguro-vida-endoso-con-devolucion/error-pago",
  nextStep: "/comprar/seguro-vida-endoso-con-devolucion/gracias",
  initialStep: "/comprar/seguro-vida-endoso-con-devolucion",
};

export const RIGHT_OF_WITHDRAWAL_MODEL = {
  content: [
    {
      title: "Tus beneficiarios",
      paragraphs: [
        "Tus beneficiarios serán tus herederos legales (Ejm: hijos, cónyuges, padres). Si deseas agregarlos o cambiarlos, ingresa a la <b>App RIMAC</b>, ve a la sección de Trámites y luego selecciona Cambios en mi póliza.",
      ],
    },
    {
      title: "Desafiliación al débito automático",
      paragraphs: [
        "Si deseas desafiliarte del débito automático con tarjeta de débito o crédito de tu seguro de Vida, contáctanos a través de los siguientes canales: llama a la Central de Atención al (01) 411-1111 (Op. 4) o envía un <span>correo a</span> <b>atencionalcliente@rimac.com.pe.</b> Procesaremos tu solicitud en un plazo máximo de dos (02) días hábiles, y un Ejecutivo de Servicio te guiará en el proceso. Verificaremos que tu póliza no tenga deudas pendientes ni esté endosada a terceros (por ejemplo, alguna entidad financiera) bajo el correspondiente Endoso de Cesión de Derechos Indemnizatorios. La desafiliación del débito automático implica migrar automáticamente al pago en la APP de Rimac o a través de una entidad financiera.<br>Dicha modalidad se encuentra sujeta a la aplicación de una tasa de interés compensatorio que se te informará durante el proceso de desafiliación.",
      ],
    },
    {
      title: "Derecho de arrepentimiento",
      paragraphs: [
        "Podrás arrepentirte de esta contratación dentro de los 15 días siguientes a la fecha en que recibiste tu póliza de seguro, <span>escribiendo a</span> <b>atencionalcliente@rimac.com.pe</b> (con el asunto “Derecho de arrepentimiento”), indicando tu nombre y DNI. Tu póliza se considerará anulada desde la fecha en que recibimos tu correo y te devolveremos la totalidad de lo pagado en caso no hayas hecho uso de alguna de las coberturas y/o asistencias. La devolución se realizará al medio de pago utilizado para contratar esta póliza, dentro de los 30 días siguientes a la fecha en que te hayas arrepentido. Recuerda que no seremos responsables en caso se presente un siniestro con posterioridad a la fecha de anulación de tu póliza.",
      ],
    },
  ],
};
